import { Box, Button, Container, Typography } from '@mui/material'
// biome-ignore lint/style/useImportType: <not a type only import>
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface ErrorPageProps {
  message: string
  linkMenu?: boolean
  onRetry?: () => void
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  message,
  linkMenu = false,
  onRetry,
}) => {
  const location = useLocation()
  const isOnHomePage = location.pathname === '/'
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Typography variant="h2" component="h1" gutterBottom sx={{ mb: 3 }}>
          Oops! Something went wrong
        </Typography>

        <Typography
          variant="h6"
          component="p"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: '600px' }}
        >
          {message}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {onRetry && (
            <Button variant="contained" onClick={onRetry} size="large">
              Try Again
            </Button>
          )}

          {linkMenu && !isOnHomePage && (
            <Button variant="outlined" component={Link} to="/" size="large">
              Go to Home
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  )
}

export default ErrorPage
